import * as React from "react";
import { Dialog, DialogContent, DialogHeader, DialogFooter, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Link } from "react-router";
import { useTranslation } from "react-i18next";

type IProps = {
  text: string;
  className?: string;
};

// TODO: check all cases
// TODO: add user tag
export function DynamicTextWithLink({ text, className }: IProps) {
  const { t } = useTranslation();
  const urlRegex = /(https?:\/\/[^\s]+)/g;
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const [pendingUrl, setPendingUrl] = React.useState<string | null>(null);

  const parts = React.useMemo(() => text.split(urlRegex), [text]);

  const isExternal = (url: string) => url.startsWith("http://") || url.startsWith("https://");

  const handleLinkClick = (e: React.MouseEvent<HTMLAnchorElement>, url: string) => {
    if (isExternal(url)) {
      e.preventDefault();
      setPendingUrl(url);
      setDialogOpen(true);
    }
  };

  const handleProceed = () => {
    if (pendingUrl) {
      window.open(pendingUrl, "_blank", "noopener noreferrer");
      setDialogOpen(false);
      setPendingUrl(null);
    }
  };

  return (
    <>
      <span className={className}>
        {parts.map((part, idx) =>
          urlRegex.test(part) ? (
            isExternal(part) ? (
              <a
                href={part}
                key={idx}
                className="text-blue-500 underline"
                onClick={e => handleLinkClick(e, part)}
              >
                {part}
              </a>
            ) : (
              <Link
                to={part}
                key={idx}
                className="text-blue-500 underline"
              >
                {part}
              </Link>
            )
          ) : (
            <span key={`post-content-${idx}`} data-lov-id={`keyc-${idx}`} className="dark:text-white/80">{part}</span>
          )
        )}
      </span>
      <Dialog open={dialogOpen} onOpenChange={setDialogOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>{t("community.dynamicTextWithLink.externalLinkTitle")}</DialogTitle>
            <DialogDescription>
              {t("community.dynamicTextWithLink.externalLinkDescription")}
            </DialogDescription>
          </DialogHeader>
          <DialogFooter>
            <Button variant="ghost" onClick={() => setDialogOpen(false)}>
              {t("community.dynamicTextWithLink.cancel")}
            </Button>
            <Button onClick={handleProceed}>
              {t("community.dynamicTextWithLink.continue")}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}